// menuData — F9.2 WAVE 2B · structure for HeaderV3 mega-menu.
// Groups: Prodotto, Soluzioni, Risorse (Prezzi is a direct link).
// Some routes are placeholders (`/v3#anchor` or `/blog` etc.); TODO tracked
// in `/app/memory/f9_2_wave2b_header_v3_build.md`.

export const MENU_GROUPS = [
    {
        key: "prodotto",
        i18n: "menu.prodotto",
        items: [
            { key: "motore_lead", i18n: "menu.prodotto_items.motore_lead", href: "/v3#tecnologia" },
            { key: "sequence_ai", i18n: "menu.prodotto_items.sequence_ai", href: "/v3#tecnologia" },
            { key: "campagne", i18n: "menu.prodotto_items.campagne", href: "/v3#tecnologia" },
            { key: "dashboard", i18n: "menu.prodotto_items.dashboard", href: "/dashboard" },
            { key: "tecnologia", i18n: "menu.prodotto_items.tecnologia", href: "/v3#tecnologia" },
        ],
    },
    {
        key: "soluzioni",
        i18n: "menu.soluzioni",
        items: [
            { key: "sales_manager", i18n: "menu.soluzioni_items.sales_manager", href: "/v3#soluzione" },
            { key: "agenzie", i18n: "menu.soluzioni_items.agenzie", href: "/v3#soluzione" },
            { key: "freelancer", i18n: "menu.soluzioni_items.freelancer", href: "/v3#soluzione" },
            { key: "enterprise", i18n: "menu.soluzioni_items.enterprise", href: "mailto:sales@globalleadsuite.io" },
        ],
    },
    {
        key: "risorse",
        i18n: "menu.risorse",
        items: [
            { key: "blog", i18n: "menu.risorse_items.blog", href: "/blog" },
            { key: "academy", i18n: "menu.risorse_items.academy", href: "/v3#faq" },
            { key: "community", i18n: "menu.risorse_items.community", href: "/community" },
            { key: "docs", i18n: "menu.risorse_items.docs", href: "/v3#faq" },
            { key: "case_study", i18n: "menu.risorse_items.case_study", href: "/v3#risultati" },
        ],
    },
];

export const DIRECT_LINKS = [
    { key: "prezzi", i18n: "menu.prezzi", href: "/v3#pricing" },
];
